import { Carousel, Row, Col, Tag, Button, Flex, Typography, Grid } from "antd";
import { EyeOutlined, PhoneOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const RelatedProducts = ({ products = [], navigate }) => {
  const [current, setCurrent] = useState(0);
  const screens = useBreakpoint();
  const carouselRef = useRef(null);

  const getSlidesToShow = () => {
    if (window.innerWidth < 576) return 1;
    if (window.innerWidth < 992) return 2;
    return 3;
  };

  const slidesToShow = getSlidesToShow();

  return (
    <div className="overflow-hidden">
      <div className="flex justify-center items-center mb-6 flex-col">
        <Title
          className="!font-medium !text-danger !text-2xl !mb-1 text-center"
          level={2}
        >
          <span className="text-primary">Related </span> Tours
        </Title>
        <Paragraph className="!mb-0">
          Culture, nature, thrills, and record-breaking experiences
        </Paragraph>
      </div>

      <div className="relative">
        {/* LEFT */}
        <button
          onClick={() => carouselRef.current.prev()}
          disabled={current === 0}
          className={`absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center
    ${current === 0 ? "bg-gray-200 cursor-not-allowed" : "bg-white shadow"}`}
        >
          <LeftOutlined />
        </button>

        {/* RIGHT */}
        <button
          onClick={() => carouselRef.current.next()}
          disabled={current >= products.length - slidesToShow}
          className={`absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center
    ${
      current >= products.length - slidesToShow
        ? "bg-gray-200 cursor-not-allowed"
        : "bg-white shadow"
    }
  `}
        >
          <RightOutlined />
        </button>

        <Carousel
          ref={carouselRef}
          className="related-carousel"
          dots={false}
          infinite={false}
          slidesToShow={3}
          slidesToScroll={1}
          beforeChange={(oldIndex, newIndex) => setCurrent(newIndex)}
          responsive={[
            {
              breakpoint: 1200,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 992,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 576,
              settings: { slidesToShow: 1 },
            },
          ]}
        >
          {products.map((tour) => {
            const title =
              tour.title || tour.attributes?.title || "Untitled Tour";

            const slug = tour.slug || tour.attributes?.slug || "untitled-tour";

            const subSlug =
              tour.sub_product?.slug ||
              tour.attributes?.sub_product?.data?.attributes?.slug ||
              "guided-tours";

            const type = tour.type;
            const final_price = tour.final_price;
            const old_price = tour.old_price;
            const save_price = tour.save_price;
            const duration = tour.duration;

            const imageUrl =
              tour.images?.[0]?.url ||
              tour.attributes?.images?.data?.[0]?.attributes?.url ||
              "https://via.placeholder.com/400x250?text=No+Image";

            return (
              <div key={tour.id} className="px-0 md:px-2 h-full w-full">
                <div className="mb-6 bg-white rounded-xl overflow-hidden shadow-custom hover:shadow-xl flex flex-col h-full">
                  <div
                    className="relative cursor-pointer"
                    onClick={() => navigate(`/${subSlug}/${slug}`)}
                  >
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%]">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-base font-semibold text-white">
                          AED {final_price}
                        </div>
                        <div className="line-through text-white text-md">
                          AED {old_price}
                        </div>
                        <div className="text-white text-md">
                          AED {save_price}
                        </div>
                      </div>
                    </div>

                    <img
                      src={`${process.env.REACT_APP_API_URL}${imageUrl}`}
                      alt={title}
                      className="w-full h-[170px] object-cover"
                    />

                    <div className="bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex justify-center w-[80px] h-[80px]">
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  <div className="p-5 pt-1 flex flex-col flex-1 justify-between">
                    <div className="mt-3 mb-0 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black rounded border-0 text-[11px] ml-2">
                        {type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-md leading-snug line-clamp-2">
                      {title}
                    </div>

                    <div className="text-primary mt-0 font-medium">
                      {duration} &nbsp;
                    </div>

                    <Flex className="mt-0 gap-3" vertical>
                      <Button
                        type="danger"
                        size="small"
                        icon={<EyeOutlined />}
                        className="mb-3 font-medium flex-1 py-3 text-xs bg-danger hover:bg-red-700 border-none text-white w-full"
                        onClick={() => navigate(`/${subSlug}/${slug}`)}
                      >
                        View Details
                      </Button>

                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="rotate-90" />}
                        className="font-medium flex-1 py-3 text-xs border-gray-400 text-gray-500 rounded-lg"
                      >
                        Call US
                      </Button>
                    </Flex>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default RelatedProducts;
